import ShapeFile from './ShapeFile';

export default ShapeFile;
